export enum GamesName {
  QuemSouEu = 'quem-sou-eu',
}